import { render, staticRenderFns } from "./procSendLabel.vue?vue&type=template&id=14be87ff&scoped=true"
import script from "./procSendLabel.vue?vue&type=script&lang=js"
export * from "./procSendLabel.vue?vue&type=script&lang=js"
import style0 from "./procSendLabel.vue?vue&type=style&index=0&id=14be87ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14be87ff",
  null
  
)

export default component.exports